export default () => {
    const hasPort = /[0-9]/.test(process.env.VUE_APP_API_URL)

    return {
        host: hasPort ? process.env.VUE_APP_API_URL : window.location.origin,
        path: hasPort ? '' : '/crmapi/socket.io'
    }
}